import View from 'cdna/core/view';
import markup from './contactView.html';

export default View.extend({
    el: markup,
    events: {
        'click button': 'close'
    },
    close: function() {
        this.$el.modal('hide');
        View.prototype.close.call(this);
    },
    render() {
        this.$el.modal({
            backdrop: true
        });

        return this;
    }
});



/** WEBPACK FOOTER **
 ** ./client/contactView.js
 **/